import { User } from './types';

/* eslint-disable */
export function getMapUsers(users: User[]) {
  return users.map((i: User) => ({
    ...i,
    name: `${i.firstName} ${i.lastName}`
  }));
}
